import { createTheme } from '@mui/material';

export const DefaultTheme = createTheme({
  palette: {
    primary: {
      main: '#6F6F6F',
    },
    secondary: {
      main: '#E10511',
    },
    success: {
      main: '#4CAF50',
    },
  },
  typography: {
    fontFamily: 'Barlow Semi Condensed, sans-serif',
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.MuiInputBase-sizeSmall': {
            height: '48px',
            fontSize: '1rem',
          },
        },
      },
    },
  }
});
